module.exports = __webpack_public_path__ + "img/humanresource.c2e6800b.png";